<div class="popup-dialog">
    <div class="trezo-card w-100 border-radius d-block bg-white border-0 shadow-none">
        <div class="trezo-card-header d-flex align-items-center justify-content-between">
            <div class="trezo-card-title">
                <h5 class="mb-0">
                    {{ titleText }}
                </h5>
            </div>
            <div class="trezo-card-subtitle">
                <button (click)="toggleClass()" class="p-0 border-0 lh-1 bg-transparent transition">
                    <i class="ri-close-fill"></i>
                </button>
            </div>
        </div>
        <form [formGroup]="frmGroup" (ngSubmit)="onSave()">
            <div class="trezo-card-content v-scroll">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                No <span class="text-danger">*</span>
                            </label>
                            <input appCapitalizeWords type="text" class="form-control" placeholder="No"
                                formControlName="noControl" maxlength="100" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['noControl']!.hasError('required')
                                ">
                                No is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['noControl']!.hasError('onlyWhitespace')
                                ">
                                No can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Name
                            </label>
                            <input appCapitalizeWords type="text" class="form-control" placeholder="Name"
                                formControlName="nameControl" maxlength="100" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['nameControl']!.hasError('onlyWhitespace')
                                ">
                                Name can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Tenant <span class="text-danger">*</span>
                            </label>
                            <select class="form-select" formControlName="tenantControl" [compareWith]="tenantComparer"
                                (change)="
                                    onTenantChange(f['tenantControl'].value)
                                " [ngClass]="{
                                    'is-invalid':
                                        isSubmitted &&
                                        f['tenantControl']!.hasError('required')
                                }">
                                <option [ngValue]="null" disabled>
                                    Please Select
                                </option>
                                <option *ngFor="let c of tenant$ | async" [ngValue]="c">
                                    {{ c.name }}
                                </option>
                            </select>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['tenantControl']!.hasError('required')
                                ">
                                Tenant is required.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Category <span class="text-danger">*</span>
                            </label>
                            <!-- Checkbox to toggle -->
                            <div class="form-check mb-2" *ngIf="currentDieId === 0">
                                <input type="checkbox" class="form-check-input" id="isNewCategory"
                                    [checked]="isNewCategory" (change)="toggleNewCategory($event)" />
                                <label class="form-check-label" for="isNewCategory">
                                    Add New Category
                                </label>
                            </div>
                            <!-- Dropdown for existing category -->
                            <select *ngIf="!isNewCategory" class="form-select" formControlName="categoryControl"
                                [compareWith]="categoryComparer" [ngClass]="{
                           'is-invalid': isSubmitted && f['categoryControl']!.hasError('required')
                           }">
                                <option [ngValue]="null" disabled>Please Select</option>
                                <option *ngFor="let c of category" [ngValue]="c">{{ c.name }}</option>
                            </select>
                            <!-- Textbox for new category -->
                            <input *ngIf="isNewCategory" type="text" class="form-control"
                                placeholder="Enter New Category" formControlName="newCategoryControl" maxlength="100" />
                            <!-- Validation -->
                            <div class="form-text text-danger"
                                *ngIf="isSubmitted && !isNewCategory && f['categoryControl']!.hasError('required')">
                                Category is required.
                            </div>
                            <div class="form-text text-danger"
                                *ngIf="isSubmitted && isNewCategory && f['newCategoryControl']!.hasError('required')">
                                New Category is required.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="col-12 text-center">
                                <label class="main-label d-block fw-medium text-black">
                                    Photo or PDF
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <div class="d-flex align-items-center">
                                <!-- Photo Upload -->
                                <div class="me-3">
                                    <input #fileInput type="file" id="photo" class="form-control"
                                        (change)="onPhotoSelected($event)" accept="image/*" />
                                    <div class="form-text text-danger" *ngIf="
                                            isSubmitted &&
                                            f['photoUrlControl']!.hasError(
                                                'required'
                                            )
                                        ">
                                        Photo is required.
                                    </div>
                                </div>

                                <!-- Separator -->
                                <span class="mx-3 fw-bold text-black">|</span>

                                <!-- PDF Upload -->
                                <div class="me-3 btn-box">
                                    <button type="button"
                                        class="primary d-inline-block fw-medium border-0 border-radius transition"
                                        (click)="openPdfToImagePopup()">
                                        <span class="position-relative d-inline-block">
                                            <i class="material-symbols-outlined">upload</i>
                                            Upload PDF
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Image Preview -->
                    <div class="col-md-6">
                        <div *ngIf="die.photoBase64 || die.photoUrl">
                            <img [src]="
                                    die.photoBase64
                                        ? die.photoBase64
                                        : getImageUrl(die.photoUrl)
                                " alt="Preview" width="200" style="border: 1px solid #ccc" />
                            <br />
                            <button type="button" class="btn btn-sm btn-outline-danger d-flex align-items-center mt-2"
                                (click)="removeImage()">
                                <i class="material-symbols-outlined me-1">delete</i>
                                Remove Photo
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <hr />
                        <h5 class="fw-bold">Die Details</h5>
                    </div>

                    <div class="col-md-3 mb-3">
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="addDetailRow()">
                            + Add Die Detail
                        </button>
                    </div>

                    <!-- Die Details Section -->
                    <div class="col-12">
                        <div formArrayName="dieDetails">
                            <div *ngFor="
                                    let group of dieDetailsArray.controls;
                                    let i = index
                                " [formGroupName]="i" class="row g-2 mb-3 align-items-end">
                                <div class="col-md-2">
                                    <input appCapitalizeWords type="text" class="form-control" placeholder="Section No"
                                        formControlName="sectionNo" />
                                    <div class="text-danger small" *ngIf="
                                            group.get('sectionNo')?.invalid &&
                                            group.get('sectionNo')?.touched
                                        ">
                                        Section No is required.
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <input class="form-control" placeholder="A" formControlName="a" />
                                    <div class="text-danger small" *ngIf="
                                            group
                                                .get('a')
                                                ?.hasError('required') &&
                                            group.get('a')?.touched
                                        ">
                                        A is required.
                                    </div>
                                    <div class="text-danger small" *ngIf="
                                            group
                                                .get('a')
                                                ?.hasError('pattern') &&
                                            group.get('a')?.touched
                                        ">
                                        A must be a decimal number.
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <input class="form-control" placeholder="B" formControlName="b" />
                                    <div class="text-danger small" *ngIf="
                                            group
                                                .get('b')
                                                ?.hasError('required') &&
                                            group.get('b')?.touched
                                        ">
                                        B is required.
                                    </div>
                                    <div class="text-danger small" *ngIf="
                                            group
                                                .get('b')
                                                ?.hasError('pattern') &&
                                            group.get('b')?.touched
                                        ">
                                        B must be a decimal number.
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <input class="form-control" placeholder="T" formControlName="t" />
                                    <div class="text-danger small" *ngIf="
                                            group
                                                .get('t')
                                                ?.hasError('invalidDecimal') &&
                                            group.get('t')?.touched
                                        ">
                                        T must be a valid decimal number.
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <input class="form-control" placeholder="Weight" formControlName="weight" />
                                    <div class="text-danger small" *ngIf="
                                            group
                                                .get('weight')
                                                ?.hasError('required') &&
                                            group.get('weight')?.touched
                                        ">
                                        Weight is required.
                                    </div>
                                    <div class="text-danger small" *ngIf="
                                            group
                                                .get('weight')
                                                ?.hasError('weightFormat') &&
                                            group.get('weight')?.touched
                                        ">
                                        Format: 12.123-45.678
                                    </div>
                                </div>
                                <div class="col-md-1 d-flex align-items-center justify-content-center">
                                    <button type="button" class="btn btn-outline-danger btn-sm"
                                        (click)="removeDetailRow(i)" title="Delete">
                                        <span class="material-symbols-outlined">delete</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <button type="button" (click)="toggleClass()"
                        class="warn d-inline-block fw-medium border-0 border-radius transition">
                        Cancel
                    </button>
                    <button class="primary d-inline-block fw-medium border-0 border-radius transition"
                        [disabled]="!formIsValid() || !dataHasChanged()">
                        <span class="position-relative d-inline-block">
                            <i class="material-symbols-outlined"> add </i>
                            {{ titleButton }}
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- Pdf to Image Popup -->

<div class="add-new-popup" [class.active]="classAppliedPdfToImage">
    <app-pdf-to-image *ngIf="classAppliedPdfToImage" (saveConfirmationEvent)="saveConfirmationPdfToImageEvent($event)"
        (classApplied)="classAppliedPdfToImageEvent($event)" />
</div>